import React from "react";
import { apiPostAsync, apiRequestAsync } from "../../utils/api_service";
import { API_URL } from "../../constants/api";
import RenderInlineForm from "./RenderInlineForm";
import RenderChart from "../common/Chart/RenderChart";
import moment from "moment";
import Settings from "@material-ui/icons/Settings";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import ViewIcon from "@material-ui/icons/VisibilityOutlined";

import CloneIcon from "@material-ui/icons/FileCopyOutlined";
import DeleteIcon from "@material-ui/icons/DeleteOutlineOutlined";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import MoreVertOutlined from "@material-ui/icons/MoreVertOutlined";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import PropertyMapComponent from "../common/map/map-component";
import DenseTable from "./RenderTable";
import RenderKeyValueForm from "./RenderKeyValueForm";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import camelcaseKeys from "camelcase-keys";
import PropTypes from "prop-types";
import Workbook from "react-excel-workbook";
import CompareIcon from "@material-ui/icons/Compare";
import {
  getKeyValueData,
  getPropsForData,
  getChartData,
  getPropsForComparisonData
} from "../../utils/graph_service";
import {
  FormControl,
  InputLabel,
  Select,
  Input,
  MenuItem,
  Chip,
  Toolbar
} from "@material-ui/core";
import ViewComfyIcon from "@material-ui/icons/ViewComfy";
import TocIcon from "@material-ui/icons/Toc";
import Skeleton from "@material-ui/lab/Skeleton";
import { SECTIONS } from "../../constants/appConstants";
import {
  removeDuplicates,
  PaperComponent,
  GetSectionPermission
} from "../../utils/helper";
import DatePicker from "../common/DatePicker/DatePicker";
import { IoMdCloseCircleOutline } from "react-icons/io";
import _ from "lodash";

/**
 * Tab panel function
 * @param {*} props 
 * @returns 
 */
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component={"div"}
      role={"tabPanel"}
      hidden={value !== index}
      id={`full-width-tabPanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

class RenderLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      responseData: undefined,
      openMenu: false,
      anchorEl: null,
      openViewDetailsPanel: false,
      selectedTabvalue: 0,
      layoutComponent: {
        data: [],
        component: <></>
      },
      drillDownConfig: {
        isDrillDown: false,
        config: [
          {
            key: "",
            type: "YTD",
            accessor: "",
            level: 1,
            seriesItem: {}
          }
        ],
        currentLevel: 1
      },
      ComparisonData: [],
      openComparisonDetailsPanel: false,
      ComparisonProperties: [],
      cardView: false
    };
  }

  /**
   * onload call
   */
  componentDidMount() {
    this.GetData(
      this.props.propertyId,
      this.props.startDate,
      this.props.endDate,
      this.props.widgetconfig
    );
  }

  /**
   * onload call with latest props or values available
   * @param {*} newProps 
   */
  componentWillReceiveProps(newProps) {
    if (
      newProps.propertyId != this.props.propertyId ||
      newProps.startDate != this.props.startDate ||
      newProps.endDate != this.props.endDate ||
      newProps.layoutUpdated != this.props.layoutUpdated
    ) {
      this.GetData(
        newProps.propertyId,
        newProps.startDate,
        newProps.endDate,
        newProps.widgetconfig
      );
    }
  }

  /**
   * function to handle open comparison panel details
   */
  handleOpenComparisonDetailsPanel = () => {
    const { openComparisonDetailsPanel } = this.state;
    this.setState(
      {
        openComparisonDetailsPanel: !openComparisonDetailsPanel,
        ComparisonProperties: [
          localStorage.getItem("selectedPropertyId").toString()
        ]
      },
      () => {
        if (this.state.openComparisonDetailsPanel == true) {
          this.handleOnDataCenterChange([
            localStorage.getItem("selectedPropertyId").toString()
          ]);
        } else {
          this.GetData(
            localStorage.getItem("selectedPropertyId").toString(),
            this.props.startDate,
            this.props.endDate,
            this.props.widgetconfig
          );
        }
      }
    );
  };

  /**
   * call on camparison date range
   * @param {*} startDate 
   * @param {*} endDate 
   */
  onComparisonDateRange = (startDate, endDate) => {
    this.setState(
      { ComparisonstartDate: startDate, ComparisonEndDate: endDate },
      () => this.handleOnDataCenterChange(this.state.ComparisonProperties)
    );
  };

  /**
   * call on data center dropdown change. (handle dd change event for datacenter)
   * @param {*} values 
   */
  handleOnDataCenterChange = values => {
    const { ComparisonData } = this.state;
    const newSet = [];
    values = removeDuplicates(values);
    values.forEach(element => {
      const obj = ComparisonData.find(x => element == x.propertyId);
      if (obj != undefined) {
        newSet.push(obj);
      }
    });
    this.setState(
      {
        ComparisonData: newSet,
        ComparisonProperties: values
      },
      () => {
        values.forEach(element => {
          this.GetData(
            element,
            this.state.ComparisonstartDate,
            this.state.ComparisonEndDate,
            this.props.widgetconfig,
            true
          );
        });
      }
    );
  };

  /**
   *  drill dropdown event
   * @param {*} isDrillDown 
   * @param {*} key 
   * @param {*} type 
   * @param {*} accessor 
   * @param {*} level 
   * @param {*} seriesItem 
   */
  onDrillDown = (isDrillDown, key, type, accessor, level, seriesItem) => {
    const { drillDownConfig } = this.state;
    const temp = drillDownConfig;
    const removeIndex = temp.config.map(item => item.level).indexOf(level);
    ~removeIndex && temp.config.splice(removeIndex, 1);
    // console.log("after back");
    if (isDrillDown) {
      temp.config.push({ key: key, type, accessor, level, seriesItem });
    }

    temp.currentLevel = level;
    temp.isDrillDown = isDrillDown;

    this.setState({ drillDownConfig: temp });
  };

  /**
   * fetch data from apis
   * @param {*} propertyId 
   * @param {*} startDate 
   * @param {*} endDate 
   * @param {*} widgetconfig 
   * @param {*} forComparison 
   */
  GetData = (propertyId, startDate, endDate, widgetconfig, forComparison) => {
    this.setState({
      responseData: undefined
    });
    if (widgetconfig.isForPerformance == true) {
      this.GetPerformanceData(
        propertyId,
        startDate,
        endDate,
        widgetconfig,
        forComparison
      );
    } else {
      const params = {
        sourceName: widgetconfig.dataUrl,
        propertyId: propertyId,
        startDate: startDate,
        endDate: endDate
      };
      apiPostAsync({
        url: API_URL.widget.GetWidgetSourceData,
        params: params,
        postBody: []
      }).then(({ data: response }) => {
        const result = camelcaseKeys(response, { deep: true });
        if (forComparison != true) {
          this.setState({
            ignoreColumns: result.ignoreColumns || [],
            responseData: result.data,
            rawData: result.rawData,
            layoutComponent: this.getWidgetLayout(
              widgetconfig,
              result.data,
              false,
              propertyId
            ),
            ComparisonstartDate: startDate,
            ComparisonEndDate: endDate
          });
        } else {
          this.setComparisonData(
            propertyId,
            startDate,
            endDate,
            widgetconfig,
            result.data,
            result.ignoreColumns
          );
        }
      });
    }
  };

  /**
   * Set data for comparison
   * @param {*} propertyId 
   * @param {*} startDate 
   * @param {*} endDate 
   * @param {*} widgetconfig 
   * @param {*} result 
   * @param {*} ignoreColumns 
   */
  setComparisonData = (
    propertyId,
    startDate,
    endDate,
    widgetconfig,
    result,
    ignoreColumns
  ) => {
    const propertyName =
      this.props.datacenterList.find(x => x.propertyID == propertyId).name ||
      "";
    const { ComparisonData, ComparisonProperties } = this.state;

    const filterCompareData = ComparisonData.filter(
      x => x.propertyId !== propertyId
    );

    // if (ComparisonData.find(x => x.propertyId == propertyId) == undefined) {
    filterCompareData.push({
      propertyId,
      propertyName,
      layoutComponent: this.getWidgetLayout(
        widgetconfig,
        result,
        false,
        propertyId
      )
    });
    // } else {
    //   ComparisonData.find(
    //     x => x.propertyId == propertyId
    //   ).layoutComponent = this.getWidgetLayout(
    //     widgetconfig,
    //     result,
    //     false,
    //     propertyId
    //   );
    // }
    ComparisonProperties.push(propertyId);
    this.setState({
      ComparisonData: filterCompareData,
      ComparisonProperties: removeDuplicates(ComparisonProperties),

      ComparisonstartDate: startDate,
      ComparisonEndDate: endDate,
      ignoreColumns: ignoreColumns || []
    });
  };

  /**
   * fetch Performance data from apis
   * @param {*} propertyId 
   * @param {*} startDate 
   * @param {*} endDate 
   * @param {*} widgetconfig 
   * @param {*} forComparison 
   */
  GetPerformanceData = (
    propertyId,
    startDate,
    endDate,
    widgetconfig,
    forComparison
  ) => {
    const params = {
      propertyId: propertyId,
      startDate: startDate,
      endDate: endDate,
      reportId: widgetconfig.reportId,
      type:
        moment(startDate).format("YYYY") === moment(endDate).format("YYYY") &&
        moment(startDate).format("MM") === moment(endDate).format("MM")
          ? "Month"
          : "YTD",
      isCalenderView: false,
      selectedAttribute: widgetconfig.attributeId.toString(),
      cloudOrgId: 2,
      dataHall: this.state.selectedDataHall
    };
    apiRequestAsync({
      url: API_URL.reports.PerformanceTrendByDate,
      params: params
    }).then(response => {
      const result = response.data;
      if (forComparison != true) {
        this.setState({
          responseData: result,
          ignoreColumns: response.ignoreColumns || [],
          layoutComponent: this.getWidgetLayout(
            widgetconfig,
            result,
            false,
            propertyId
          ),
          ComparisonstartDate: startDate,
          ComparisonEndDate: endDate
        });
      } else {
        this.setComparisonData(
          propertyId,
          startDate,
          endDate,
          widgetconfig,
          result
        );
      }
    });
  };

  /**
   * onclick event
   * @param {*} event 
   */
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget, openMenu: true });
  };

  /**
   * onclose handle event
   */
  handleClose = () => {
    this.setState({ anchorEl: null, openMenu: false });
  };

  /**
   * Fetch widget layout information
   * @param {*} widgetconfig 
   * @param {*} responseData 
   * @param {*} onlyData 
   * @param {*} propertyId 
   * @returns 
   */
  getWidgetLayout = (
    widgetconfig,
    responseData,
    onlyData = false,
    propertyId
  ) => {
    const startDate =
      this.state.openComparisonDetailsPanel === true
        ? this.state.ComparisonstartDate
        : this.props.startDate;
    const endDate =
      this.state.openComparisonDetailsPanel === true
        ? this.state.ComparisonEndDate
        : this.props.endDate;

    if (widgetconfig.isConfigurable || widgetconfig.isForPerformance) {
      let configuration = JSON.parse(
        JSON.stringify(widgetconfig.configuration)
      );
      configuration = camelcaseKeys(JSON.parse(configuration));
      let data = [];

      // 1: inline Form
      if (widgetconfig.widgetType == 1) {
        data = getKeyValueData(responseData, configuration);
        if (onlyData == true) return data;
        return {
          data: data,
          isKeyValue: true,
          component: (
            <RenderKeyValueForm
              data={data}
              identifier={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
            />
          )
        };
      }

      // 2: Key Value Form
      if (widgetconfig.widgetType == 2) {
        data = getKeyValueData(responseData, configuration);
        if (onlyData == true) return data;
        return {
          data: data,
          isKeyValue: true,
          component: (
            <RenderInlineForm
              data={data}
              identifier={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
            />
          )
        };
      }

      //3: Table value Chart
      if (widgetconfig.widgetType == 3) {
        if (onlyData == true) return responseData;
        return {
          data: responseData,
          component: (
            <DenseTable
              columns={configuration.columns}
              data={responseData}
              identifier={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
            />
          )
        };
      }
      let PerformanceRawData = [];
      if (widgetconfig.isForPerformance) {
        if (responseData.data != undefined)
          if (
            responseData.data[0].yAxisLabel != undefined &&
            responseData.data[0].yAxisLabel != null
          ) {
            configuration.yAxisLabel = responseData.data[0].yAxisLabel;
          }
        if (
          responseData.data[0].xAxisLabel != undefined &&
          responseData.data[0].xAxisLabel != null
        ) {
          configuration.xAxisLabel = responseData.data[0].xAxisLabel;
        }
        PerformanceRawData = responseData.rawData;
        responseData.data = responseData.data[0].data;
      }
      //4: Multiline Chart
      if (widgetconfig.widgetType == 4) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : getChartData(responseData, configuration, startDate, endDate);
        if (onlyData == true) return resData.data;

        return {
          data: resData.data,
          isKeyValue: false,
          accessor: resData.chartAccessor.mainAccessor,
          keys: resData.barKeys,
          unit: resData.unit,
          xAxisLabel: configuration.xAxisLabel,
          component: (
            <RenderChart
              identifier={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}
              onDrillDown={this.onDrillDown}
              allowDrillDown
              chartConfig={{
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: widgetconfig.isForPerformance
                  ? PerformanceRawData
                  : responseData,
                data: resData.data,
                yAxisLabel: configuration.yAxisLabel,
                type: "LineChart",
                multiLineChartAccessors: resData.chartAccessor,
                accessor: resData.chartAccessor.mainAccessor,
                colors: resData.colors,
                unit: resData.unit,
                widgetconfig: widgetconfig,
                xAxisLabel: configuration.xAxisLabel
              }}
            />
          )
        };
      }

      //5: Bar Chart

      if (widgetconfig.widgetType == 5) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : getKeyValueData(responseData, configuration, true);
        if (onlyData == true) return resData.data;

        return {
          data: resData.data,
          isKeyValue: true,
          component: (
            <RenderChart
              identifier={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}
              onDrillDown={this.onDrillDown}
              allowDrillDown
              chartConfig={{
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: responseData,
                data: resData.data,
                yAxisLabel: configuration.yAxisLabel,
                type: "BarChart",
                colors: resData.colors,
                unit: resData.unit,
                widgetconfig: widgetconfig
              }}
            />
          )
        };
      }

      //6: Donut Chart
      if (widgetconfig.widgetType == 6) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : getKeyValueData(responseData, configuration, true);
        if (onlyData == true) return resData.data;

        return {
          data: resData.data,
          isKeyValue: true,
          component: (
            <RenderChart
              identifier={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}
              onDrillDown={this.onDrillDown}
              allowDrillDown
              chartConfig={{
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: responseData,
                data: resData.data,
                type: "DonutChart",
                colors: resData.colors,
                unit: resData.unit,
                widgetconfig: widgetconfig
              }}
            />
          )
        };
      }

      //7: Pie Chart
      if (widgetconfig.widgetType == 7) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : getKeyValueData(responseData, configuration, true);

        if (onlyData == true) return resData.data;
        return {
          data: resData.data,
          isKeyValue: true,
          component: (
            <RenderChart
              identifier={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}
              onDrillDown={this.onDrillDown}
              allowDrillDown
              chartConfig={{
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: responseData,
                data: resData.data,
                type: "PieChart",
                colors: resData.colors,
                unit: resData.unit,
                widgetconfig: widgetconfig
              }}
            />
          )
        };
      }

      //8: Stack bar Chart
      if (widgetconfig.widgetType == 8) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : getChartData(responseData, configuration, startDate, endDate);
        if (onlyData == true) return resData.data;
        return {
          data: resData.data,
          isKeyValue: false,
          accessor: resData.chartAccessor.mainAccessor,
          keys: resData.barKeys,
          unit: resData.unit,
          xAxisLabel: configuration.xAxisLabel,
          component: (
            <RenderChart
              identifier={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}
              onDrillDown={this.onDrillDown}
              allowDrillDown
              chartConfig={{
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: widgetconfig.isForPerformance
                  ? PerformanceRawData
                  : responseData,
                data: resData.data,
                yAxisLabel: configuration.yAxisLabel,
                type: "StackBarChart",
                keys: resData.barKeys,
                colors: resData.barColors,
                accessor: resData.chartAccessor.mainAccessor,
                unit: resData.unit,
                widgetconfig: widgetconfig,
                xAxisLabel: configuration.xAxisLabel
              }}
            />
          )
        };
      }

      //9: Group Bar Chart
      if (widgetconfig.widgetType == 9) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : getChartData(responseData, configuration, startDate, endDate);
        if (onlyData == true) return resData.data;
        return {
          data: resData.data,
          isKeyValue: false,
          accessor: resData.chartAccessor.mainAccessor,
          keys: resData.barKeys,
          unit: resData.unit,
          xAxisLabel: configuration.xAxisLabel,
          component: (
            <RenderChart
              identifier={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout_chart" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}
              onDrillDown={this.onDrillDown}
              allowDrillDown
              chartConfig={{
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: widgetconfig.isForPerformance
                  ? PerformanceRawData
                  : responseData,
                data: resData.data,
                yAxisLabel: configuration.yAxisLabel,
                type: "GroupBarChart",
                keys: resData.barKeys,
                colors: resData.barColors,
                accessor: resData.chartAccessor.mainAccessor,
                unit: resData.unit,
                widgetconfig: widgetconfig,
                xAxisLabel: configuration.xAxisLabel
              }}
            />
          )
        };
      }
    } else {
      if (onlyData == true) return responseData;
      if (widgetconfig.widgetType == 1) {
        return {
          data: responseData,
          isKeyValue: true,
          component: (
            <RenderKeyValueForm
              data={responseData}
              identifier={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
            />
          )
        };
      }
      if (widgetconfig.widgetType == 2) {
        return {
          data: responseData,
          isKeyValue: true,
          component: (
            <RenderInlineForm
              data={responseData}
              identifier={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
              key={
                "Child_layout" +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && "preview") +
                (this.state.openComparisonDetailsPanel != true
                  ? propertyId
                  : "true" + propertyId)
              }
            />
          )
        };
      }
      if (widgetconfig.widgetType == 10) {
        return {
          data: responseData,
          component: (
            <PropertyMapComponent
              key={"RenderLayoutProperty"}
              propertyList={responseData || []}
            />
          )
        };
      }
    }
    return {
      data: [],
      component: <></>
    };
  };

  /**
   * function for calculation
   * @param {*} array 
   * @param {*} key 
   * @returns 
   */
  totalCount = (array, key) => {
    return array.reduce((r, a) => {
      return r + a[key];
    }, 0);
  };

  /**
   * view onclick event handler
   */
  viewData = () => {
    const {openViewDetailsPanel} =this.state;
    this.setState({ openViewDetailsPanel: !openViewDetailsPanel });
  };

  /**
   * set tab properties
   * @param {*} index 
   * @returns 
   */
  tabProps = index => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabPanel-${index}`
    };
  };

  /**
   * onclick handle event for tab change
   * @param {*} event 
   * @param {*} newValue 
   */
  handleTabChange = (event, newValue) => {
    this.setState({ selectedTabvalue: newValue });
  };

  /**
   * onclick handle event for tab index change 
   * @param {*} newValue 
   */
  handleTabChangeIndex = newValue => {
    this.setState({ selectedTabvalue: newValue });
  };

  /**
   * Data Download functionality
   * @param {*} responseData 
   * @param {*} widgetconfig 
   * @returns 
   */
  DownloadData = (responseData, widgetconfig) => {
    const { ignoreColumns } = this.state;
    const propsSheet1 = getPropsForData(
      "summary",
      responseData,
      widgetconfig,
      this.state.layoutComponent.data
    );
    const propsSheet2 = getPropsForData(
      "Details",
      widgetconfig.isForPerformance == true
        ? responseData.rawData
        : widgetconfig.isConfigurable == false && widgetconfig.widgetType !== 10
        ? this.state.rawData
        : responseData,
      widgetconfig,
      this.state.layoutComponent.data
    );

    propsSheet1.columns = propsSheet1.columns.filter(
      ar =>
        !(ignoreColumns || []).find(
          rm => _.camelCase(rm) === _.camelCase(ar.key)
        )
    );

    propsSheet2.columns = propsSheet2.columns.filter(
      ar =>
        !(ignoreColumns || []).find(
          rm => _.camelCase(rm) === _.camelCase(ar.key)
        )
    );
    return (
      <Workbook
        filename={
          widgetconfig.title +
          " from " +
          this.props.startDate.replace("/", "_") +
          " to " +
          this.props.endDate.replace("/", "_") +
          "_data.xlsx"
        }
        element={
          <ListItem
            button
            divider
            onClick={() => {
              this.handleClose();
            }}
          >
            <ListItemIcon>
              {" "}
              <DownloadIcon fontSize={"small"} />
            </ListItemIcon>
            <ListItemText primary={"Download Data"} />
          </ListItem>
        }
      >
        <Workbook.Sheet data={propsSheet1.data} name={"summary"}>
          {propsSheet1.columns.map(column => (
            <Workbook.Column label={column.name} value={column.key} />
          ))}
        </Workbook.Sheet>
        <Workbook.Sheet data={propsSheet2.data} name={"Detail sheet"}>
          {propsSheet2.columns.map(column => (
            <Workbook.Column label={column.name} value={column.key} />
          ))}
        </Workbook.Sheet>
      </Workbook>
    );
  };

/**Stop Propogation */
  stopPropagation = (event) => {
    event.stopPropagation();
  };

  /**
   * onload event for child table
   * @param {*} row 
   * @returns 
   */
  renderChildTable = row => {
    return (
      <DenseTable
        columns={row.child.columns}
        data={row.child.data}
        config={{
          minRows: 10,
          evenRowClass: "table-even",
          oddRowClass: "table-odd"
        }}
      />
    );
  };

  render() {
    const {
      responseData,
      openMenu,
      anchorEl,
      openViewDetailsPanel,
      openComparisonDetailsPanel,
      selectedTabvalue,
      ComparisonProperties,
      ComparisonData,
      ComparisonstartDate,
      ComparisonEndDate,
      ignoreColumns
    } = this.state;
    const { widgetconfig } = this.props;
    
    const compProperties = removeDuplicates(ComparisonProperties);

    const DashboardWidgetConfig = GetSectionPermission(
      SECTIONS.DASHBOARD,
      SECTIONS.DASHBOARD_WIDGET_CONFIG
    );
    return (
      <>
        {widgetconfig && (
          <>
            <div
              className={"dashboard-widget-wrapper"}
              key={
                widgetconfig.usersWidgetMappingId +
                "_Wrapper" +
                (this.props.IsInPreviewMode && "preview")
              }
              data-grid={{ x: 4, y: 0, w: 1, h: 2 }}
            >
              <div className={"dashboard-widget-header"}>
                {widgetconfig.title}

                {this.props.IsInPreviewMode != true && (
                  // <Tooltip title="More Option">
                  <IconButton
                    aria-label={"CloseIconAddWidgetPanel"}
                    size={"small"}
                    aria-describedby={
                      "PopOver" +
                      widgetconfig.usersWidgetMappingId +
                      "_Wrapper" +
                      (this.props.IsInPreviewMode && "preview")
                    }
                    color={"primary"}
                    onClick={this.handleClick}
                    onMouseDown={this.stopPropagation}
                    onTouchStart={this.stopPropagation}
                  >
                    <MoreVertOutlined
                      className={"white-button"}
                      fontSize={"small"}
                      size={"small"}
                    />
                  </IconButton>
                  // </Tooltip>
                )}
              </div>

              {responseData ? (
                <div
                  className={"dashboard-widget-data-container"}
                  key={
                    widgetconfig.usersWidgetMappingId +
                    "_Container" +
                    (this.props.IsInPreviewMode && "preview")
                  }
                  // onDragStart={e => {
                  //   e.preventDefault();
                  //   e.stopPropagation();
                  // }}
                >
                  {" "}
                  {(this.state.layoutComponent || {}).component || (
                    <Skeleton
                      animation={"wave"}
                      variant={"rect"}
                      width={"100%"}
                      height={"100%"}
                    />
                  )}
                </div>
              ) : (
                //this.getWidgetLayout(widgetconfig, responseData)
                <Skeleton
                  animation={"wave"}
                  variant={"rect"}
                  width={"100%"}
                  height={"100%"}
                />
              )}
            </div>
            {openMenu && (
              <Popover
                id={
                  "PopOver" +
                  widgetconfig.usersWidgetMappingId +
                  "_Wrapper" +
                  (this.props.IsInPreviewMode && "preview")
                }
                open={openMenu}
                anchorEl={anchorEl}
                onClose={this.handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
              >
                <List
                  component={"nav"}
                  aria-label={"mailbox folders"}
                  className={"widgetMenu"}
                >
                  {DashboardWidgetConfig.accessTypeId != 4 ? (
                    <>
                      <ListItem
                        button
                        disabled={!widgetconfig.isConfigurable}
                        onClick={() => {
                          this.handleClose();
                          this.props.OpenWidgetConfigurationPanel(
                            { ...widgetconfig },
                            responseData[0]
                          );
                        }}
                      >
                        <ListItemIcon>
                          <Settings fontSize={"small"} />
                        </ListItemIcon>
                        <ListItemText fontSize={"small"} primary={"Configure"} />
                      </ListItem>
                      <Divider />
                    </>
                  ) : null}

                  <ListItem
                    divider
                    button
                    onClick={() => {
                      this.handleClose();
                      this.viewData(responseData, widgetconfig);
                    }}
                  >
                    <ListItemIcon>
                      {" "}
                      <ViewIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText primary={"View Data"} />
                  </ListItem>

                  <Divider />
                  <ListItem
                    divider
                    button
                    onClick={() => {
                      this.handleClose();
                      this.handleOpenComparisonDetailsPanel();
                    }}
                  >
                    <ListItemIcon>
                      {" "}
                      <CompareIcon fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText primary={"Compare Data"} />
                  </ListItem>
                  {responseData &&
                    this.DownloadData(responseData, widgetconfig)}
                  {/* <ListItem divider>
                                <CSVLink className="csvlink" data={this.getDownloadData(responseData, widgetconfig)}
                                    filename={widgetconfig.Title + " data.csv"}><ListItemIcon> <DownloadIcon fontSize="small" /></ListItemIcon>
                                    <ListItemText primary="Download Data" /></CSVLink>
                            </ListItem> */}
                  <ListItem
                    button
                    disabled={!widgetconfig.isConfigurable}
                    onClick={() => {
                      this.handleClose();
                      const cloneConfig = { ...widgetconfig };
                      cloneConfig.usersWidgetMappingId = 0;
                      cloneConfig.title = "Copy of " + cloneConfig.title;
                      cloneConfig.isClone = true;
                      this.handleClose();
                      this.props.OpenWidgetConfigurationPanel(
                        cloneConfig,
                        responseData[0]
                      );
                    }}
                  >
                    <ListItemIcon>
                      {" "}
                      <CloneIcon fontSize={"small"} />{" "}
                    </ListItemIcon>
                    <ListItemText primary={"Clone this widget"} />
                  </ListItem>
                  <Divider light />
                  <ListItem
                    button
                    onClick={() => {
                      this.handleClose();
                      this.props.onRemoveWidgetMapping(
                        widgetconfig.usersWidgetMappingId
                      );
                    }}
                  >
                    <ListItemIcon>
                      {" "}
                      <DeleteIcon fontSize={"small"} />{" "}
                    </ListItemIcon>
                    <ListItemText primary={"Remove Widget"} />
                  </ListItem>
                </List>

                <Typography />
              </Popover>
            )}
            {openViewDetailsPanel && (
              <Dialog
                fullScreen={false}
                open={openViewDetailsPanel}
                maxWidth={"lg"}
                onClose={() => this.viewData()}
                aria-labelledby={"n-responsive-dialog-title"}
                PaperComponent={PaperComponent}
              >
                <DialogTitle id={"n-responsive-dialog-title"}>
                  {widgetconfig.title + " (Data)"}
                </DialogTitle>
                <DialogContent>
                  <AppBar position={"static"} color={"default"}>
                    <Tabs
                      value={selectedTabvalue}
                      onChange={this.handleTabChange}
                      indicatorColor={"primary"}
                      textColor={"primary"}
                      variant={"fullWidth"}
                      aria-label={"full width tabs example"}
                    >
                      <Tab label={"Summary Data"} {...this.tabProps(0)} />
                      <Tab label={"Details"} {...this.tabProps(1)} />
                    </Tabs>
                  </AppBar>

                  <TabPanel value={selectedTabvalue} index={0}>
                    {(responseData || []).length > 0 ||
                    (widgetconfig.isForPerformance &&
                      responseData.rawData.length > 0) ? (
                      responseData && (
                        <DenseTable
                          {...getPropsForData(
                            "summary",
                            responseData,
                            widgetconfig,
                            this.state.layoutComponent.data
                          )}
                          ignoreColumns={ignoreColumns}
                        />
                      )
                    ) : (
                      <div style={{ width: "100%", textAlign: "center" }}>
                        {"Data Not Available\r"}
                      </div>
                    )}
                  </TabPanel>
                  <TabPanel value={selectedTabvalue} index={1}>
                    {(responseData || []).length > 0 ||
                    (widgetconfig.isForPerformance &&
                      responseData.rawData.length > 0) ? (
                      responseData && (
                        <DenseTable
                          {...getPropsForData(
                            "details",
                            widgetconfig.isForPerformance == true
                              ? responseData.rawData || []
                              : widgetconfig.isConfigurable == false &&
                                widgetconfig.widgetType !== 10
                              ? this.state.rawData || []
                              : responseData || [],
                            widgetconfig,
                            this.state.layoutComponent.data
                          )}
                          ignoreColumns={ignoreColumns}
                        />
                      )
                    ) : (
                      <div style={{ width: "100%", textAlign: "center" }}>
                        {"Data Not Available\r"}
                      </div>
                    )}
                  </TabPanel>
                </DialogContent>
              </Dialog>
            )}

            {openComparisonDetailsPanel && (
              <Dialog
                fullScreen
                open={openComparisonDetailsPanel}
                onClose={this.handleOpenComparisonDetailsPanel}
                title={widgetconfig.title}
              >
                <AppBar
                  style={{ position: "relative", backgroundColor: "#064473" }}
                >
                  <Toolbar>
                    <Typography
                      variant={"h6"}
                      style={{ marginLeft: "10px", flex: "1" }}
                    >
                      {"Comparison View - " + widgetconfig.title}
                    </Typography>
                    <Tooltip title={"Close"}>
                      <IconButton
                        edge={"end"}
                        color={"inherit"}
                        onClick={this.handleOpenComparisonDetailsPanel}
                        aria-label={"close"}
                        className={"white-button"}
                      >
                        <IoMdCloseCircleOutline />
                      </IconButton>
                    </Tooltip>
                  </Toolbar>
                </AppBar>
                <DialogContent>
                  <div className={"row col-xs-12"}>
                    <div className={"col-xs-10"}>
                      <FormControl
                        key={"FormControl_DC_Compare-master-label"}
                        className={"col-xs-12"}
                      >
                        <InputLabel id={"multiple-master-label"}>
                          {"Value(s)\r"}
                        </InputLabel>
                        <Select
                          labelId={"multiple-master-label"}
                          id={"multiple-master-select"}
                          multiple
                          value={removeDuplicates(compProperties)}
                          onChange={event => {
                            this.handleOnDataCenterChange(event.target.value);
                          }}
                          input={
                            <Input
                              key={"multiple-master-chipInput"}
                              id={"multiple-master-chipInput"}
                            />
                          }
                          renderValue={selected => (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap"
                              }}
                            >
                              {removeDuplicates(selected).map(
                                (value, columnIndex) => (
                                  <Chip
                                    key={"chip" + columnIndex}
                                    label={
                                      this.props.datacenterList.find(
                                        x => x.propertyID == value
                                      ).name || ""
                                    }
                                    style={{ margin: 2 }}
                                    onDelete={() => {
                                      const values = compProperties.filter(
                                        x => x != value
                                      );
                                      this.handleOnDataCenterChange(values);
                                    }}
                                  />
                                )
                              )}
                            </div>
                          )}
                          // MenuProps={MenuProps}
                        >
                          {this.props.datacenterList.map((data, ic) => (
                            <MenuItem
                              key={"masterOption" + ic}
                              value={data.propertyID.toString()}
                            >
                              {data.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className={"col-xs-auto"} style={{ paddingTop: "28px" }}>
                      {this.state.cardView ? (
                        <Tooltip title={"Switch to Table View"}>
                          <IconButton size={"small"}>
                            <TocIcon
                              size={"small"}
                              onClick={() => {
                                this.setState({
                                  cardView: false
                                });
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title={"Switch to Card View"}>
                          <IconButton size={"small"}>
                            <ViewComfyIcon
                              size={"small"}
                              onClick={() => {
                                this.setState({
                                  cardView: true
                                });
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}{" "}
                      <DatePicker
                        onDateChange={this.onComparisonDateRange}
                        startDate={ComparisonstartDate}
                        endDate={ComparisonEndDate}
                      />
                    </div>
                  </div>
                  {this.state.cardView == false ? (
                    <div className={"row col-xs-12"}>
                      <DenseTable
                        {...getPropsForComparisonData(
                          ComparisonData,
                          widgetconfig,
                          this.renderChildTable
                        )}
                        ignoreColumns={ignoreColumns}
                      />
                    </div>
                  ) : (
                    <div
                      className={"row col-xs-12"}
                      style={{ marginTop: "10px" }}
                    >
                      {ComparisonData &&
                        ComparisonData.map(item => (
                          <div className={"col-xs-4"}>
                            <div
                              className={"dashboard-widget-wrapper"}
                              key={
                                widgetconfig.usersWidgetMappingId +
                                "_Wrapper_comparison" +
                                item.propertyId
                              }
                            >
                              <div className={"dashboard-widget-header"}>
                                {this.props.datacenterList.find(
                                  x => x.propertyID == item.propertyId
                                ).name || ""}
                              </div>
                              <div
                                className={"dashboard-widget-data-container"}
                                key={
                                  widgetconfig.usersWidgetMappingId +
                                  "_Container_comparison" +
                                  item.propertyId
                                }
                                style={{ minHeight: 30 * widgetconfig.height }}
                              >
                                {item.layoutComponent.component}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </DialogContent>
              </Dialog>
            )}
          </>
        )}
      </>
    );
  }
}
export default RenderLayout;
